import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Error from "../Base-Component/Error/Error";
import { privateRouters, publicRouters, moduleRoutes } from "./allRoutes";
import MainLayout from "../Layouts/MainLayout/MainLayout";
import PrivateRoute from "./privateRoute";
import PublicRoute from "./publicRoute";
import DeleteAccount from "../Page/DeleteAccount/DeleteAccount";
import { allowModuleApi } from "../Services/ApiServices";
import Cookies from "js-cookie";
import toast from "react-hot-toast";

function RouterData() {
  const [privateRoutes, setPrivateRoutes] = useState(privateRouters);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const roleData = JSON.parse(localStorage.getItem("e-learn-data"));

        if (roleData?.role === "sub_admin") {
          const obj = { user_id: roleData.userId };
          const response = await allowModuleApi(obj);

          const allowedModuleIds = response.data.data.map(
            (item) => item.module_id
          );
          const filteredRoutes = allowedModuleIds
            .map((id) => moduleRoutes[id])
            .filter(Boolean)
            .flat();

          setPrivateRoutes(filteredRoutes);
        } else {
          setPrivateRoutes(privateRouters);
        }
      } catch (err) {
        if (err?.response?.status === 401) {
          Cookies.remove("e_learning_token");
        } else {
          toast.error(err?.response?.data?.message || "Something went wrong");
        }
        setPrivateRoutes(privateRouters);
      } finally {
        setIsLoading(false);
      }
    };

    fetchModules();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>; 
  }
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<Error />} />
        <Route path="/delete_account" element={<DeleteAccount />} />

        {publicRouters.map((item, index) => (
          <Route
            key={index}
            path={item.path}
            element={<PublicRoute>{item.element}</PublicRoute>}
          />
        ))}

        {privateRoutes.map((item, index) => (
          <Route
            key={index}
            path={item.path}
            element={
              <PrivateRoute>
                <MainLayout>{item.element}</MainLayout>
              </PrivateRoute>
            }
          />
        ))}
      </Routes>
    </BrowserRouter>
  );
}

export default RouterData;
